import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes, FilterType,
} from 'app/enums/common.enums'

import {
    ContainerCode, ContainerVolume, TemperatureRange,
} from 'app/enums/label.enums'

const config: SkyNetTableConfig = {
    name: 'ContainerTypes',
    tabs: [{
        name: 'Container Type',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'containerModel',
                reduced: true,
                labelKey: 'CONTAINER_MODEL',
            },
            {
                name: 'containerCode',
                reduced: true,
                componentName: 'EnumValue',
                allowedValuesEnum: ContainerCode,
                filterType: FilterType.Array,
                filterField: 'containerCode',
                labelKey: 'CONTAINER_CODE',
            },
            {
                name: 'containerVolume',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: ContainerVolume,
                filterField: 'containerVolume',
                labelKey: 'CONTAINER_VOLUME',
            },
            {
                name: 'temperatureRange',
                reduced: true,
                componentName: 'EnumValue',
                allowedValuesEnum: TemperatureRange,
                labelKey: 'TEMPERATURE_RANGE',
            },
            {
                name: 'isPrototype',
                componentName: 'ChipCheckMark',
                sorting: false,
                filterType: FilterType.Array,
                filterField: 'isPrototype',
                labelKey: 'IS_PROTOTYPE',
            },
        ],
    }],
}

export default config
